import { Observer } from 'mobx-react-lite'
import type { IColumn } from 'shared/ui/TableNew'
import { EmptyCell } from 'shared/ui'
import { AiCallingStatus } from 'entities/AICalling/ui/AiCallingStatus/AiCallingStatus'
import { type CallingListItem } from '../store/CallingListItem'

export const columns: IColumn<CallingListItem>[] = [
  {
    field: 'name',
    name: 'Name',
    renderRowCell: (row) => row.name,
  },
  {
    field: 'status',
    name: 'Status',
    renderRowCell: (row) => <Observer>{() => <AiCallingStatus status={row.status} />}</Observer>,
  },
  {
    field: 'totalCals',
    name: 'Total calls',
    renderRowCell: (row) => <Observer>{() => <>{row.totalCals || <EmptyCell />}</>}</Observer>,
  },
]
